const base_url = 'https://backend.dev.boyot.app/api/';
export const environment = {
    production: true,
    URL: base_url
};
